import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Home from '@/components/ExampleComponent'
import Entrance from '@/components/Index'

import HelpIndex from '@/components/help/Index'
import HelpEntrance from '@/components/help/Entrance'
import HelpSeries from '@/components/help/Series'
import HelpHandicap from '@/components/help/Handicap'
import HelpSandbagging from '@/components/help/Sandbagging'

import HelpTest from '@/components/help/Test'

import GameDetail from '@/components/normal_game_detail/Index'
import GameDetailTable from '@/components/normal_game_detail/Table'

import FAQ from '@/components/fidohome_faq/FAQ'
import Tutorial from '@/components/fidohome_faq/Tutorial'

export default new VueRouter({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        }, {
            path: '/help',
            component: Entrance,
            children: [{
                path: '',
                name: 'helpIndex',
                component: HelpIndex
            }, {
                path: '',
                component: HelpEntrance,
                children: [{
                    path: 'rating',
                    name: 'rating',
                    component: HelpSeries
                }, {
                    path: 'handicap',
                    name: 'handicap',
                    component: HelpHandicap
                }, {
                    path: 'sandbagging',
                    name: 'sandbagging',
                    component: HelpSandbagging
                }, {
                    path: 'test',
                    name: 'test',
                    component: HelpTest
                }, {
                    path: 'faq',
                    name: 'faq',
                    component: FAQ
                }]
            }]
        },
        {
            path: '/normal_game_detail',
            component: GameDetail,
            props: (route) => ({ playerId: route.query.playerId }),
            children: [{
                path: '01gameOIDO',
                name: 'getOIDONormalRatingDetail',
                component: GameDetailTable
            }, {
                path: '01gameOIOO',
                name: 'getOIOONormalRatingDetail',
                component: GameDetailTable
            }, {
                path: 'Cricket',
                name: 'getCricketNormalRatingDetail',
                component: GameDetailTable
            }, {
                path: 'CountUp',
                name: 'getCountUpNormalRatingDetail',
                component: GameDetailTable
            }]
        },
        {
            path: '/fidohome_faq',
            name: 'FAQ',
            component: FAQ
        },
        {
            path: '/fidohome_bluetooth',
            name: 'Tutorial',
            component: Tutorial
        },
        {
            path: "*",
            redirect: "/"
        }
    ]
})
